export default {
  index: [
    {
      path: '/zktgruser',
      component: resolve => require(['./zkpromoterinfoIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpromoter_info/_router.js